
























































































/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { exists, currency } from '@/util/inputValidation'
import CurrencyInput from '@/components/inputs/CurrencyInput.vue'
import * as payments from '@/services/payments'
import { getMyOrganization } from '@/services/organizations'
import { Organization } from '@/types/Organizations'

@Component({
  components: {
    CurrencyInput,
  },
})
export default class TransferFundsDialog extends Vue {
  isValid = false
  loading = false
  loadingMyOrganization = false
  loadingFundingSources = false
  rules = {
    amount: [
      currency
    ],
    location: [exists('You must choose a funding source.')],
  }
  transfer = {
    amount: 0,
    location: '',
    transfer_speed: 'standard',
  }

  @Prop({ default: false }) readonly opened!: boolean
  @Prop(String) readonly action!: 'add' | 'remove' | null

  @Watch('opened')
  onOpened(opened: boolean) {
    if (opened) {
      // Set amount to how much is in balance
      if (this.action == 'remove')
        this.transfer.amount = this.$store.state.payments.balance.value
      else this.transfer.amount = 0

      // Set funding source to the first option
      if (this.fundingSources.length)
        this.transfer.location = this.fundingSources[0]._links.self.href

      this.transfer.transfer_speed = 'standard'
    }
  }

  get myOrganization(): Organization {
    return this.$store.getters.myOrganization
  }

  get sameDayFee() {
    if (!this.myOrganization) return null
    return this.transfer.amount * parseFloat(this.myOrganization.subscription_tier?.business_same_day_fee)
  }

  get achFee() {
    if (!this.myOrganization) return null
    return this.transfer.amount * parseFloat(this.myOrganization.subscription_tier?.business_ach_fee)
  }

  closeDialog() {
    (this.$refs.form as HTMLFormElement).reset()
    this.$emit('update:opened', null)
  }

  async mounted() {
    Promise.all([
      this.getMyOrganziation(),
      this.getFundingSources(),
    ])
  }

  async getMyOrganziation() {
    this.loadingMyOrganization = true
    try {
      await getMyOrganization(this.$store)
    }
    finally {
      this.loadingMyOrganization = false
    }
  }

  async getFundingSources() {
    this.loadingFundingSources = true
    try {
      await payments.loadFundingSources(this.$store)
    }
    finally {
      this.loadingFundingSources = false
    }
  }

  async sendTransfer() {
    this.loading = true
    try {
      if (this.action === 'add') {
        await payments.addToBalance(this.$store, this.transfer)
      }
      else {
        await payments.removeFromBalance(this.$store, this.transfer)
      }
    }
    finally {
      this.loading = false
      this.closeDialog()
    }
  }

  get fundingSources() {
    return this.$store.getters.fundingSources
  }
}
